import Resource from '@/api/Resource';
import TestQuestionAnswer from './TestQuestionAnswer';

class TestQuestion extends Resource {
  $name = 'questions';

  $defaults() {
    return {
      id: null,
      test_id: null,
      type: 'choice',
      title: '',
      description: '',
      multiple: 0,
      free_answer: 0,

      hasChanges: false, // Custom has changes
    };
  }

  $fill({ answers }) {
    if (answers) {
      this.answers = TestQuestionAnswer.collection(answers);
    }
  }

  /**
   * Состоит ли ответ на данный вопрос в виде выбора?
   *
   * @returns {boolean}
   */
  hasChoice() {
    return ['choice', 'image'].includes(this.type);
  }
}

export default TestQuestion;
